import { Typography } from "@mui/material";

export default function Title({ children }) {
    return <Typography
        variant="h6"
        align="left"
        style={{
            color: '#103168',
            fontWeight: 600,
            textAlign: 'center',
            marginBottom: 20
        }}
    >
        {children}
    </Typography>
}